import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import type { Menu } from '@/Interfaces/Data';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import styles from './styles.module.scss';
import useScreenType from '@/hooks/util/useScreenType';
import { setMenuOpened, setRouteActive } from '@/_store/modules/layout';
import {
  selectMenuOpened,
  selectRouteActive,
} from '@/_store/modules/layout/selectors';

interface MenuItemProps {
  menu: Menu;
}

function MenuItem({ menu }: MenuItemProps) {
  const { href, icon, key, title } = menu;

  const menuOpened = useAppSelector(selectMenuOpened);
  const routeActive = useAppSelector(selectRouteActive);
  const dispatch = useAppDispatch();
  const isMobile = useScreenType('mobile');

  const isActived = routeActive?.key === key;

  function handleClickMenuItem() {
    if (isMobile) {
      dispatch(setMenuOpened(!menuOpened));
    }

    dispatch(setRouteActive(menu));
  }

  return (
    <div className={styles.menu} data-actived={isActived}>
      <Link to={href} onClick={handleClickMenuItem}>
        <span className={styles.icon}>
          {typeof icon === 'string' ? (
            <i role="figure" className={`fa-kit ${icon}`} />
          ) : (
            <FontAwesomeIcon
              role="figure"
              title={icon.iconName}
              icon={icon}
              size="1x"
            />
          )}
        </span>
        <span className={styles.label}>{title}</span>
      </Link>
    </div>
  );
}

export { MenuItem };
